/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var getRangesForTree = function getRangesForTree(_ref) {
  var data = _ref.data,
    initialOffset = _ref.initialOffset,
    rowHeightManager = _ref.rowHeightManager,
    initialScrollTop = _ref.initialScrollTop;
  var ranges = data.map(function (row, i) {
    if (!row) {
      return;
    }
    var rowHeight = rowHeightManager.getRowHeight(i);
    var top = rowHeightManager.getRowOffset(i);
    var offset = top + initialOffset - (initialScrollTop || 0);
    var bottom = offset + rowHeight;
    var nodeProps = row.__nodeProps;
    var result = {
      top: offset,
      bottom: bottom,
      height: rowHeight,
      index: i,
      keyPath: nodeProps.key,
      depth: nodeProps.depth,
      parent: nodeProps.initialNodes !== undefined
    };
    return result;
  });
  return ranges;
};
var _default = getRangesForTree;
exports.default = _default;